const AnnouncementBar = () => {
    return (
     <>
      <div className="bg-[#eec6c6] text-center p-2 text-sm font-serif">
        💕 10% DISCOUNT ON YOUR FIRST ORDER: <span className="font-bold max-sm:whitespace-pre"> (Use Code) BOOKLET10 💕 </span>
      </div>
     </>
    );
  };
  
  export default AnnouncementBar;